import { Popover } from '@mui/material';
import { useState } from 'react';

import { Highlighter02Icon } from '@/components/icons/Highlighter02Icon';
import { useHighlightButton } from '@/components/TextEditor/plugins/HighlightPlugin';

import { TextEditorToolbarButton } from './ToolbarPlugin';
import { iconProps } from './ToolbarPlugin.utils';

/**
 * Toolbar button that opens a highlight color picker. Behavior (selection
 * tracking, active-state, active-color background, color application) is
 * shared with other highlight buttons via `useHighlightButton`.
 */
export function HighlightButton() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isOpen = anchorEl !== null;
  const { isActive, activeColorSx, menu } = useHighlightButton({
    isOpen,
    onClose: () => setAnchorEl(null),
  });

  return (
    <>
      <TextEditorToolbarButton
        isActive={isActive}
        onClick={(event) =>
          setAnchorEl((prev) => (prev ? null : event.currentTarget))
        }
        sx={activeColorSx}
      >
        <Highlighter02Icon {...iconProps} />
      </TextEditorToolbarButton>
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{ paper: { sx: { mt: 0.5 } } }}
      >
        {menu}
      </Popover>
    </>
  );
}
